// extracted by mini-css-extract-plugin
export default {"subscription_item_price":"nF","delete_item":"oF","subscription_item":"pF","subscription_item_img_wrapper":"qF","subscription_item_info":"rF","subscription_item_title":"sF","subscription_item_edit":"tF","subscription_item_wrapper":"uF","arrow":"vF","subscription_item_category":"wF","plus_button":"xF","more_details":"yF","old_price":"zF","discount":"AF"};
    if(module.hot) {
      // 1743628927157
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  